<template>
    <ReaderModal
        v-if="ui.confirmationModal.opened"
        :aria-label="ui.confirmationModal.title"
        @close-modal="handleCancel"
    >
        <template #header>
            <h2 :id="titleId" class="ml-4 text-lg font-medium">{{ ui.confirmationModal.title }}</h2>
        </template>
        <div class="px-4 pt-3">
            <p :id="descId" class="mb-4 text-sm text-theme-toolbar-icon">
                {{ ui.confirmationModal.message }}
            </p>
            <div class="flex justify-end gap-2">
                <BaseButton
                    ref="cancelBtn"
                    dusk="ConfirmationModalCancel"
                    :aria-label="computedCancelLabel"
                    class="flatButton"
                    @click="handleCancel"
                >
                    {{ computedCancelLabel }}
                </BaseButton>
                <!-- A deletion is confirmed in red. Any other answer keeps the Cancel's look. -->
                <BaseButton
                    ref="confirmBtn"
                    dusk="ConfirmationModalConfirm"
                    :aria-label="computedConfirmLabel"
                    :variant="isDestructive ? 'danger' : null"
                    size="sm"
                    :class="{ flatButton: !isDestructive }"
                    @click="handleConfirm"
                >
                    {{ computedConfirmLabel }}
                </BaseButton>
            </div>
        </div>
    </ReaderModal>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import ReaderModal from '../ReaderModal/ReaderModal.vue';
import BaseButton from './buttons/BaseButton.vue';

export default {
    name: 'ConfirmationModal',
    components: {
        ReaderModal,
        BaseButton,
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang']),
        titleId() {
            return `confirm-modal-title-${this._uid}`;
        },
        descId() {
            return `confirm-modal-desc-${this._uid}`;
        },
        computedConfirmLabel() {
            return this.ui.confirmationModal.confirmLabel || this.localizations[this.lang].delete;
        },
        computedCancelLabel() {
            return this.ui.confirmationModal.cancelLabel || this.localizations[this.lang].cancel;
        },
        isDestructive() {
            return this.ui.confirmationModal.destructive;
        },
    },
    methods: {
        ...mapMutations(['closeConfirmationModal']),
        handleConfirm() {
            const { onConfirmAction, context } = this.ui.confirmationModal;
            if (onConfirmAction) {
                this.$bus.$emit(onConfirmAction, context);
            }
            this.closeConfirmationModal();
        },
        handleCancel() {
            this.closeConfirmationModal();
        },
    },
};
</script>
